import styled from 'styled-components';

export const PageContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 60px 20px 120px 20px;
	width: 100%;
	max-width: 840px;
	margin: 0 auto;
`;

export const Headline = styled.h1`
	font-size: 27px;
	font-weight: 600;
	letter-spacing: -0.02em;
	color: ${(p) => p.theme.gray[1000]};
	margin: 0 0 12px 0;
	text-align: center;
`;

export const Subheading = styled.p`
	font-size: 15px;
	font-weight: 400;
	color: ${(p) => p.theme.gray[600]};
	line-height: 1.6;
	margin: 0 0 40px 0;
	text-align: center;
	max-width: 520px;
`;

export const CardGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 24px;
	width: 100%;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
	}
`;

export const Card = styled.div`
	padding: 28px;
	border-radius: 12px;
	border: 1px solid ${(p) => p.theme.gray[200]};
	background-color: ${(p) => p.theme.gray[0]};
	display: flex;
	flex-direction: column;
`;

export const CardLabel = styled.div`
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.08em;
	color: ${(p) => p.theme.gray[600]};
	margin-bottom: 12px;
`;

export const CardTitle = styled.h3`
	font-size: 22px;
	font-weight: 600;
	margin: 0 0 10px 0;
	color: ${(p) => p.theme.gray[1000]};
`;

export const CardDescription = styled.p`
	font-size: 15px;
	line-height: 1.5;
	margin: 0 0 24px 0;
	color: ${(p) => p.theme.gray[600]};
	flex: 1;
`;

export const ButtonRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 10px;
	flex-wrap: wrap;
`;
